import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const WebsiteFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="website-footer" className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://www.syndicappli.fr/wp-content/uploads/2023/04/cropped-Logo-Syndicappli_WHITE_2021_SMALL.png"
              alt="SyndicAppli"
              className="h-10 mb-6"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              L'application qui gère vos AG de copropriété. Simplifiez votre quotidien de syndic avec notre solution tout-en-un.
            </p>
            <div className="flex gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-emerald-500 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-emerald-500 transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-emerald-500 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/site" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/site/application" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  L'application
                </Link>
              </li>
              <li>
                <Link to="/site/renovation" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  Rénovation énergétique
                </Link>
              </li>
              <li>
                <Link to="/site/equipe" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  L'équipe
                </Link>
              </li>
              <li>
                <Link to="/site/contact" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Légal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  Mentions légales
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  Politique de confidentialité
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  CGU
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  Cookies
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-emerald-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400 text-sm">
                  6 rue Léonard De Vinci, CS 20119<br />
                  53000 Laval, France
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                <a href="tel:+33755608550" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  +33 7 55 60 85 50
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                <a href="mailto:contact@syndicappli.fr" className="text-slate-400 hover:text-emerald-400 transition-colors text-sm">
                  contact@syndicappli.fr
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} SyndicAppli. Tous droits réservés.
          </p>
          <p className="text-slate-500 text-sm">
            Incubé à <span className="text-emerald-400">Laval Mayenne Technopole</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export { WebsiteFooter };
